import { useEffect } from 'react';
import {
  CONSUMER_CMS_SHOPPING_CART,
  useCmsConfig,
  useMultiPlayOfferingConfiguration,
  IPortabilityCMS,
  productSpecificError,
  IGenericErrorCMS,
  errorMock,
} from '@vfit/consumer/data-access';
import { API, getClickToCallWithKeyOrUrl, regex } from '@vfit/shared/data-access';
import { ICommonData } from '@vfit/shared/models';
import {
  organizePortabilityError,
  organizePortabilityNumberCard,
} from './portabilityNumberCard.utils';
import { useCheckout } from '../../../iBuyFixed.context';
import { ID_FLOWS } from '../../checkout.constants';
import { retrieveProduct } from '../../../iBuyFixed.utils';
import TaggingPortabilityNumberCard from './portabilityNumberCard.tagging';
import PortabilityNumber from './components/PortabilityNumber/portabilityNumber';
import { useQueryClient } from 'react-query';

const PortabilityNumberCard = ({ handleOnChangeEnableGoNext, handleGoPrevSlide }: ICommonData) => {
  const {
    currentStepKey,
    checkoutErrors,
    portability,
    isModalButtonSticky,
    product,
    setPortability,
    setCurrentStepKey,
  } = useCheckout();

  const queryClient = useQueryClient();
  const productTracking = retrieveProduct();
  const { buttonGenericError, urlGenericErrorCallMeNow } = productSpecificError(productTracking);

  const portabilityNumberCardCMS = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_PORTABILITY
  ) as IPortabilityCMS;
  const genericError = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_GENERIC_ERROR
  ) as IGenericErrorCMS;
  const { isLoading, isError, error } = useMultiPlayOfferingConfiguration(
    portabilityNumberCardCMS?.portability?.operatorList
  );
  const { title, description, label } = organizePortabilityNumberCard(portabilityNumberCardCMS);
  const { titleError, messageError } = organizePortabilityError(portabilityNumberCardCMS);

  const checkPortabilityValidation = () => {
    if (portability?.portabilityNumber) {
      const isMatches = portability.portabilityNumber.match(regex['fixedNumber']);
      handleOnChangeEnableGoNext?.(!!isMatches);
    } else {
      handleOnChangeEnableGoNext?.(false);
    }
  };

  useEffect(() => {
    checkPortabilityValidation();
  }, [portability]);

  useEffect(() => {
    setCurrentStepKey(ID_FLOWS.PORTABILITY_NUMBER);
  }, []);

  useEffect(() => {
    if (isError) {
      const action = () => {
        if (handleGoPrevSlide) handleGoPrevSlide();
      };
      checkoutErrors?.showAndTrackError?.(
        genericError,
        () => action(),
        undefined,
        titleError,
        messageError,
        () => () =>
          getClickToCallWithKeyOrUrl(
            queryClient,
            urlGenericErrorCallMeNow,
            product,
            action,
            currentStepKey,
            errorMock('multiplayOfferingConfiguration', error)
          ),
        buttonGenericError,
        undefined,
        undefined,
        isModalButtonSticky
      );
    }
  }, [isError]);

  const onChangeData = (telephoneNumber: string) => {
    setPortability({
      ...portability,
      portabilityNumber: telephoneNumber || '',
      portabilityInfo: '',
    });
  };

  return (
    <>
      <TaggingPortabilityNumberCard />
      <PortabilityNumber
        title={title}
        description={description}
        label={label}
        value={portability.portabilityNumber}
        onChangeData={onChangeData}
        isLoading={isLoading}
        editorialConfigs={portabilityNumberCardCMS?.editorialconfigs?.elements}
      />
    </>
  );
};

export default PortabilityNumberCard;

